import { render } from "./PatientJourney.vue?vue&type=template&id=0e278ab5"
import script from "./PatientJourney.vue?vue&type=script&lang=js"
export * from "./PatientJourney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__